import { t } from '@/i18n';
import { BreadcrumbInfoItems } from 'src/components/SimpleBreadcrumb';

export const accessControlPermissionTypesNewBreadcrumb: BreadcrumbInfoItems = [
  {
    label: t('pages.access_control_permission_types_new.breadcrumb.label1'),
    link: '/access-control',
  },
  {
    label: t('pages.access_control_permission_types_new.breadcrumb.label2'),
    link: '/access-control/permission-types',
  },
  {
    label: t('pages.access_control_permission_types_new.breadcrumb.label3'),
  },
];
